import { AuthService } from "services/AuthService";
import { ReportService } from "services/ReportService";
import React from "react";
const authService = new AuthService()
const reportService = new ReportService()
const gettingExtraReport = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    userId: number,
    profileId: number,
    setSelected: React.Dispatch<React.SetStateAction<number[]>>,
    setCache: React.Dispatch<React.SetStateAction<number[]>>,
    setReports: React.Dispatch<React.SetStateAction<any[]>>,
    setCategories: React.Dispatch<React.SetStateAction<any[]>>
) => {
    try{
        setLoading(true);

        let categories: ProfileCategoryReportModel[] = []
        let extras: ExtraReportUserModel[] = []

        await authService.report.getExtraReport(userId, profileId)
        .then((response) => {
            categories = response.category_reports
            extras = response.extra_reports

            setCategories(categories);
        })
        .catch((error) => {
            console.error('Error al obtener los extra reports:', error.message);
        })
        .finally(() => {
            setLoading(false);
        })

        await reportService.report.getReports()
        .then((response) => {
            let reports = response;
            let reports_filter = reports.filter(report => categories.map(category => category.category_report_id).includes(report.category_id))

            for(const extra of extras){
                const report = reports.find(r => r.id === extra.report_id)
                if (!report)
                    continue;
                if(extra.is_aggregation){
                    if(!reports_filter.find(r => r.id === report.id)){
                        reports_filter.push(report)
                    }

                }else{
                    if(reports_filter.find(r => r.id === report.id)){
                        reports_filter = reports_filter.filter(r => r.id !== report.id)
                    }
                }
            }

            setReports(reports);
            setSelected(reports_filter.map(report => report.id));
            setCache(reports_filter.map(report => report.id));

            console.log('reports:', reports, 'selected', reports_filter);
        })
        .catch((error) => {
            console.error('Error al obtener los reportes:', error.message);
        })
        .finally(() => {
            setLoading(false);
        })

    }catch(error: any){
        console.error('Error durante el flujo:', error.message);
    }
}

const updatingExtraReport = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    categories: ProfileCategoryReportModel[],
    reportsToUpdate: {id: number; add: boolean}[],
    userId: number,
    closing: () => void
) => {
    try{
        setLoading(true);

        const promises =  categories.map(category => {
            const body = {
                "columns_select":["*"],
                "where_select": {
                    "category_id": category.category_report_id,
                }
            }
            return reportService.report.getReports(body)
        })

        const body: {
            ids_to_add: { report_id: number; is_aggregation: boolean; }[];
            ids_to_remove: number[];
        } = {
            ids_to_add: [],
            ids_to_remove: []
        }

        await Promise.all(promises)
        .then(responses => {
            const reports = responses.map(response => response).flat();

            console.log('reports:', reports);

            for(const r of reportsToUpdate){
                if(r.add){
                    if(reports.find(report => report.id === r.id)){
                        body.ids_to_remove.push(r.id)
                    }else{
                        body.ids_to_add.push({report_id: r.id, is_aggregation: true})
                    }
                }else{
                    if(reports.find(report => report.id === r.id)){
                        body.ids_to_add.push({report_id: r.id, is_aggregation: false})
                    }else{
                        body.ids_to_remove.push(r.id)
                    }
                }
            }
        })
        .catch((error) => {
            console.error('Error al obtener los reportes:', error.message);
        })
        .finally(() => {
            setLoading(false);
        })
        await authService.report.updateExtraReport(userId, body)
        .then((response) => {
            closing();
        })
        .catch((error) => {
            console.error('Error al obtener los reportes:', error.message);
        })
        .finally(() => {
            setLoading(false);
        })
    }catch(error: any){
        console.error('Error durante el flujo:', error.message);
    }
}

export {
    gettingExtraReport,
    updatingExtraReport
}